import gsap from 'gsap';
import { Draggable } from './util/Draggable.min.js';
import { InertiaPlugin } from './util/InertiaPlugin.min.js';
gsap.registerPlugin(Draggable, InertiaPlugin);

const init = () => {
  const resourceSliders = document.querySelectorAll('.resources-slider');
  if (!resourceSliders.length) return;

  resourceSliders.forEach((slider) => {
    const items = slider.querySelectorAll('.resources-slider__item');
    if (!items.length) return;

    items.forEach((item, i) => {
      gsap.set(item, {
        rotateY: -(i * 360) / items.length
      });
    });

    const roloTL = gsap.to(items, {
      rotateY: '+=360',
      duration: 5,
      ease: 'none',
      paused: true
    });
    // draggable consts
    const proxy = document.createElement('div');
    const itemCount = items.length;
    const itemW = items[0].offsetWidth;

    // circumference of circle
    const c = itemW * 2 * Math.PI;
    // arc distance from edge to edge (for snapping)
    const seg = c / itemCount;

    // wrap for tween progress scrub
    const wrapVal = gsap.utils.wrap(0, c);

    Draggable.create(proxy, {
      type: 'x',
      trigger: items,
      inertia: true,
      onDrag: updateProgress,
      onThrowUpdate: updateProgress,
      snap: {
        x: (x) => {
          return Math.round(x / seg) * seg;
        }
      }
    });

    function updateProgress() {
      roloTL.progress(wrapVal(this.x) / c);
    }

    items.forEach((item, i) => {
      const anchor = item.querySelector('a');
      // hack check if focus is caused by click so Safari doesn't get upset.
      let noFocusAnimation = false;

      anchor.addEventListener('mousedown', () => {
        noFocusAnimation = true;

        slider.classList.remove('focus-fade');
        setTimeout(() => {
          noFocusAnimation = false;
        }, 200);
      });

      anchor.addEventListener('focus', () => {
        if (noFocusAnimation) return;

        slider.classList.add('focus-fade');
        gsap.to(roloTL, { progress: i / items.length });
        gsap.to(proxy, { x: seg * i });
      });
    });

    // end
  });
};

export { init };
